import React from "react";
import styles from './Toast.module.scss';
import Alert from "../alert/Alert";
import PropTypes from "prop-types";
import { useToasts } from "../../contexts/ToastContext";

const Toast = () => {
  const { toasts } = useToasts();

  return (
    <div className={styles.toast}>
      {toasts.map((toast, index) => {
        return (
          <Alert
            key={`toast-${index}`}
            message={toast.message}
            type={toast.type}
            isToast={true}
          />
        );
      })}
    </div>
  );
}

Toast.propTypes = {
  toasts: PropTypes.arrayOf(
    PropTypes.shape({
      message: PropTypes.string.isRequired,
      type: PropTypes.oneOf(['success', 'error', 'warning', 'info']).isRequired,
    })
  )
};

export default Toast;